export { default as avatarOne } from './avatar-1.svg';
export { default as avatarTwo } from './avatar-2.svg';
export { default as avatarThree } from './avatar-3.svg';
export { default as avatarFour } from './avatar-4.svg';
export { default as avatarFive } from './avatar-5.svg';
export { default as avatarSix } from './avatar-6.svg';
export { default as avatarSeven } from './avatar-7.svg';
export { default as avatarEight } from './avatar-8.svg';
export { default as avatarNine } from './avatar-9.svg';
